import { default as MenuMUI } from '@material-ui/core/Menu';
import { default as MenuItemMUI } from '@material-ui/core/MenuItem';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Menu
 */
export const Menu = styled(MenuMUI)`
  .MuiMenu-paper {
    border-radius: 3px;
    width: 234px;
    max-width: 288px;
    overflow-x: initial;
    overflow-y: initial;
    transform: translate(10px, 5px) !important;
    height: 258px;
    max-height: 258px;

    .arrow {
      position: absolute;
      top: -10px;
      left: 198px;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-top: none;
      border-bottom: 12px solid white;
    }

    & .items {
      max-height: 214px;
      overflow-y: auto;
      display: block;
      margin-top: 6%;

      &::-webkit-scrollbar {
        width: 14px;
      }

      .MuiListItem-gutters {
        height: 52px;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c4c4c4;
        width: 14px;
        border: 5px solid white;
        border-radius: 10px;
      }
    }

    .MuiListItem-button:hover {
      background-color: #dce9ff;
    }
  }
`;

/**
 * Estilização do componente MenuItem
 */
export const MenuItem = styled(MenuItemMUI)`
  &.MuiMenuItem-root {
    padding: 0 0 0 16px;

    > div {
      display: flex;
      flex-direction: row;
      margin: 0 5px;
      width: 100%;

      > img {
        flex: 0 0 auto;
        width: 40px;
        height: 40px;
        margin-right: 15px;
      }

      .no-img {
        flex: 0 0 auto;
        width: 40px;
        height: 40px;
        margin-right: 15px;
        border: solid 1px #c4c4c4;
        background-color: #fff;
        overflow: hidden;

        .backslash {
          width: 3px;
          height: 60px;
          background-color: #c4c4c4;
          transform: rotate(-45deg) translate(12px, 12px);
        }
      }

      > div {
        color: #5e6366;
        width: 100%;
        display: flex;
        align-items: center;

        h4 {
          font-size: 14px;
          line-height: 16px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          margin-top: 3px;
          white-space: break-spaces;
        }
      }
    }
  }
`;
